import { actions as uiActions, selectors as uiSelectors } from 'ducks/ui';
import { actions as operationActions } from 'ducks/uiOperations';
import { actions as formActions } from 'ducks/form';
import { selectors as userFieldsSelectors, actions as userFieldActions } from 'ducks/supplierEnquiry/userFields';
import { selectors as supplierSelectors } from 'ducks/supplierEnquiry/supplier';
import { getSupplierUserFields } from 'api/supplierEnquiry/userFields';


export const mapStateToProps = state => {
  const params = new URLSearchParams(location.search);

  return {
    gridName: 'SupplierEnquiryUserFields',
    columnDefs: userFieldsSelectors.columns(state),
    rowData: userFieldsSelectors.data(state),
    isCustomerLookUpOpen: uiSelectors.isCustomerLookUpOpen(state), //to trigger update size based on drawer state change
    gridOptions: userFieldsSelectors.gridOptions(state),
    detailCellRenderer: userFieldsSelectors.detailCellRenderer(state),
    reqParams: {Supplier: supplierSelectors?.selected(state)?.Supplier || params?.get('Supplier')}
      &&
    {
      Supplier: supplierSelectors?.selected(state)?.Supplier || params?.get('Supplier')
    },
    apiMethod: supplierSelectors?.selected(state)?.Supplier || params?.get('Supplier') ? getSupplierUserFields : () => Promise.resolve(null)
  };
};

export const actions = {
  changeSelectedTab: uiActions.changeSelectedTab,
  changeOperationMode: operationActions.changeOperationMode,
  getFormSchema: formActions.search,
  changeSelectedForm: formActions.setSelectedm,
  setSelectedOrderLine: userFieldActions.setSelected
}
